<div class="content__wrapper" id="viewPages">
  <!-- Live preview - sinle image -->
  <div *ngFor="let page of contentData" id="viewPagesContent">
    <div class="live_preview" *ngIf="getUILayoutIDByName(page.UiLayout) === 2" id="livePreview">
      <div class="preview_content_single" [style.background-color]="page? page.bgColor : ''" id="previewContent">
        <div class="single_img_layout" id="singleImgLayout">
          <div class="logo_section" id="logoSecOEMPlaceholder">
            <img
              [src]="page.logoUrl || 'assets/images/OEM_layout_logo_placeholder.svg'"
              alt="logo image" />
          </div>
          <div [ngClass]="page.imageUrl ? 'imagePreview' : 'content_section'"
          [ngStyle]="{'background-image': page.imageUrl ? 'url(' + page.imageUrl + ')' : 'assets/images/layout_image_icon.svg'}" id="viewPageImgUrl">
          <h2 class="preview_heading" [ngStyle]="{'color':page ? page.titleFontColor:''}">
            {{page.title||bodyHeading}}</h2>
          <div class="preview_text"
            [ngStyle]="{'color':page ? page.titleFontColor:'','font-size':fontSize(page.bodyCopyFontSize)}" id="previewTxt">
            {{page.bodyCopy||bodyLabel}}
          </div>
        </div>
        </div>
      </div>
    </div>

    <!-- Live preview - multi image -->
    <div class="live_preview" *ngIf="getUILayoutIDByName(page.UiLayout) === 1" id="uiLayout">
      <div class="preview_content multi_img_layout"
        [style.background-color]="page? page.bgColor : ''" id="multiImgLayout">
        <div class="small_img" id="imgFluidOEmPage">
          <img class="img-fluid"
            [src]="page.imageAUrl || 'assets/images/OEM_page1_img_A.svg'"
            alt="image A" />
          <div class="preview_text"
            [ngStyle]="{'color':page ? page.titleFontColor:'','font-size':fontSize(page.bodyCopyAFontSize)}" id="bodyCopyLabelA">
            {{page.bodyCopyA||bodyLabelA}}</div>
          <img class="img-fluid"
            [src]="page.imageBUrl || 'assets/images/OEM_page1_img_B.svg'"
            alt="image A" />
          <div class="preview_text"
            [ngStyle]="{'color':page ? page.titleFontColor:'','font-size':fontSize(page.bodyCopyBFontSize)}" id="bodyCopyLabelB">
            {{page.bodyCopyB||bodyLabelB}}</div>
        </div>
        <div class="hero_img" id="heroImg">
          <div class="logo_section" id="logoSecOEMLayoutLogo">
            <img
              [src]="page.logoUrl || 'assets/images/OEM_layout_logo_placeholder.svg'"
              alt="logo image" />
          </div>
          <div class="preview_hero_text" [ngStyle]="{'color':page ? page.titleFontColor:''}" id="titleBodyHeading">
            {{page.title||bodyHeading}}</div>
          <img [ngClass]="page ? 'heroPreview' : 'img-fluid'"
            [src]="page.heroUrl || 'assets/images/OEM_page1_hero_img.svg'"
            alt="Hero Image" />
        </div>
      </div>
    </div>

    <!-- Live preview - video image -->
    <div class="live_preview" *ngIf="getUILayoutIDByName(page.UiLayout) === 3" id="livePreviewVideo">
      <div class="preview_content" [style.background-color]="page? page.bgColor : ''" id="previewConBgColor">
        <div class="video_layout" id="previewVideoLayout">
          <div class="logo_section" id="logoSecOEMLayoutSVG">
            <img
              [src]="page.logoUrl || 'assets/images/OEM_layout_logo_placeholder.svg'"
              alt="logo image" />
          </div>
          <div class="content_section" *ngIf="!page" id="conSecVideoIcon">
            <!-- Write video instead of image here -->
            <img class="video_icon_filled" alt="video Image" />
          </div>
          <div class="video_preview" *ngIf="page" id="videoPreviewUUrl">
            <video [src]="page.videoUrl" controls class="video1"></video>
          </div>
          <h2 class="preview_heading" [ngStyle]="{'color':page ? page.titleFontColor:''}">
            {{page.title||bodyHeading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>